import * as React from "react";
import ContentFramingRow from "./ContentFramingMatrix";
import Ring from "@/components/ui/Ring";
import { FramingRow, FramingMode } from "@/types/contentFraming";
import { Popover } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

interface TitleAndSourceProps {
  rows: FramingRow[];
  placeholderOptions: { value: string; label: string }[];
  onToggle: (id: string, enabled: boolean) => void;
  onSelectionChange: (id: string, value: string) => void;
  onInputTextChange: (id: string, value: string) => void;
  onModeChange: (id: string, mode: FramingMode) => void;
  onUpdateFieldsFromShape: (id: string, shapeId: string) => void;
  onHoverShape: (shapeId: string | null) => void;
}

export const TitleAndSource: React.FC<TitleAndSourceProps> = ({
  rows,
  placeholderOptions,
  onToggle,
  onSelectionChange,
  onInputTextChange,
  onModeChange,
  onUpdateFieldsFromShape,
  onHoverShape,
}) => {
  return (
    <>
      <div className="flex items-start justify-between mb-4">
        <h2 className="text-2xl font-bold text-gray-900">Title & Sourcing</h2>
      </div>
      <Ring className="py-8 px-4">
        <div className="flex flex-col gap-2">
          <p>With the new Share Price Performance Line Chart added to your slide. you may want to consider the following updates:</p>
        </div>

        <div className="flex flex-col items-start justify-between mt-4">
          <div className="flex w-full items-center gap-2 py-2 mt-2 mb-3 border-b border-black">
            <div className="w-[2%] text-sm font-medium text-black font-bold">Incl.</div>
            <div className="w-[11%] text-sm font-medium text-black font-bold">Framing Type</div>
            <div className="w-[20%] text-sm font-medium text-black font-bold">Placeholder Selected</div>
            <div className="w-[25%] text-sm font-medium text-black font-bold">Current Text</div>
            <div className="w-[25%] text-sm font-medium text-black font-bold">Updated Text to Include</div>
            <div className="w-[16%] text-sm font-medium text-black font-bold flex items-center gap-1">
              Formatting 
              <Popover overlayStyle={{ width: 300 }} content="This selection controls the format of the “Updated Text to Include” text that will be added to the associated placeholder. For each Framing Type, your selected Format Template has pre-designed text size, font, color, and emphasis characteristics. You can choose to use that Format Template or simply use the text formatting attributed with the Placeholder Design on your current slide." trigger="click" placement="bottom">
                <InfoCircleOutlined className="text-black cursor-pointer" />
              </Popover>
            </div>
          </div>
          <ContentFramingRow 
            row={rows[0]}   
            placeholderOptions={placeholderOptions}
            onToggle={onToggle} 
            onSelectionChange={onSelectionChange} 
            onInputTextChange={onInputTextChange} 
            onModeChange={onModeChange}
            onUpdateFieldsFromShape={onUpdateFieldsFromShape}
            onHoverShape={onHoverShape}
          />
          <ContentFramingRow 
            row={rows[1]}   
            placeholderOptions={placeholderOptions}
            onToggle={onToggle} 
            onSelectionChange={onSelectionChange} 
            onInputTextChange={onInputTextChange} 
            onModeChange={onModeChange}
            onUpdateFieldsFromShape={onUpdateFieldsFromShape}
            onHoverShape={onHoverShape}
          />
          <ContentFramingRow 
            row={rows[2]}   
            placeholderOptions={placeholderOptions}
            onToggle={onToggle} 
            onSelectionChange={onSelectionChange} 
            onInputTextChange={onInputTextChange} 
            onModeChange={onModeChange}
            onUpdateFieldsFromShape={onUpdateFieldsFromShape}
            onHoverShape={onHoverShape}
          />
          <ContentFramingRow 
            row={rows[3]}   
            placeholderOptions={placeholderOptions}
            onToggle={onToggle} 
            onSelectionChange={onSelectionChange} 
            onInputTextChange={onInputTextChange} 
            onModeChange={onModeChange}
            onUpdateFieldsFromShape={onUpdateFieldsFromShape}
            onHoverShape={onHoverShape}
          />
          <ContentFramingRow 
            row={rows[4]}   
            placeholderOptions={placeholderOptions}
            onToggle={onToggle} 
            onSelectionChange={onSelectionChange} 
            onInputTextChange={onInputTextChange} 
            onModeChange={onModeChange}
            onUpdateFieldsFromShape={onUpdateFieldsFromShape}
            onHoverShape={onHoverShape}
          />
          <ContentFramingRow 
            row={rows[5]}   
            placeholderOptions={placeholderOptions}
            notesTrue={true}
            onToggle={onToggle} 
            onSelectionChange={onSelectionChange} 
            onInputTextChange={onInputTextChange} 
            onModeChange={onModeChange}
            onUpdateFieldsFromShape={onUpdateFieldsFromShape}
            onHoverShape={onHoverShape}
          />
        </div>
      </Ring>
    </>
  );
};

export default TitleAndSource;

